export const environment = {
  siteTitle: 'EFD-PROJECT',
  production: false,
  apiUrl: 'https://admin.efd-project.etarom.it',
  baseUrl: 'https://efd-project.etarom.it',
  siteUrl: 'https://efd-project.etarom.it',
  directus_storage: 'directus_storage',
  default_route: '/progetti',
  confirm_subscription_route: '/confirm',
  presence_subscription_route: '/presence',
  subscription_route: '/subscriptions',
  logo_badge: 'b06813b5-e626-455d-b8d7-f88acf6b9244.png',
  sub_apy_key: 'F40b7nfbYvbPxorY8VU5KuIx_isxnls8',
  b_font_size: 60,
  bw: 2480,
  bh: 3508,
  tx: 1515,
  ty: 2870,
  qrcode_w: 250,
  qrcode_h: 250,
  qrcode_x: 1515,
  qrcode_y: 3050
};
